import { SelectTransactionPackageSizeArgs } from 'types/api/arguments/select-transaction-package-size-args'

import { api } from './api'

export const selectTransactionPackageSize = ({
  transactionId,
  packageSizeId,
  customShipmentPrice,
}: SelectTransactionPackageSizeArgs) =>
  api.put(`/transactions/${transactionId}/package_size`, {
    package_size_id: packageSizeId,
    custom_shipment_price: customShipmentPrice,
  })
